import { NumberBadge } from "@/components/badge/number-badge";
import { Divider } from "@/components/divider/divider";
import { FavouritesIcon } from "@/components/icons/favourites-icon";
import { RightIcon } from "@/components/icons/right-icon";
import { OutlinedButton } from "@/components/ui/buttons";
import { AddFoodModal } from "@/features/meal-plan/components/add-food-modal";
import { useGetYourFood } from "@/hooks/requests/your-food/use-get-your-food";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { useIonRouter } from "@ionic/react";
import { memo, useMemo, useState } from "react";

/**
 * Card prompting user to share their food preferences
 */
export const TellMeFoodsCard = memo(function TellMeFoodsCard() {
  const navigate = useIonRouter();
  const [isAddFoodModalOpen, setIsAddFoodModalOpen] = useState(false);
  const { yourFood } = useGetYourFood();

  const totalMeals = useMemo(() => {
    if (!yourFood) {
      return 0;
    }
    const breakfastLength = yourFood.breakfast?.length ?? 0;
    const lunchLength = yourFood.lunch?.length ?? 0;
    const dinnerLength = yourFood.dinner?.length ?? 0;
    const snackLength = yourFood.snack?.length ?? 0;
    return breakfastLength + lunchLength + dinnerLength + snackLength;
  }, [yourFood]);

  const handleOpenAddFoodModal = () => {
    setIsAddFoodModalOpen(true);
  };

  const handleCloseAddFoodModal = () => {
    setIsAddFoodModalOpen(false);
  };

  const navigateToMyFoods = () => {
    navigate.push("/plans/saved-meals?tab=your-food", "none", "push");
  };

  return (
    <div
      className={cn(
        "flex h-[230px] w-full flex-col items-center rounded-4xl",
        "relative isolate overflow-hidden",
      )}
      style={{
        WebkitMaskImage: "-webkit-radial-gradient(white, white)",
      }}
    >
      <div
        className={
          "absolute inset-0 bg-[url('/assets/images/bg-blur.png')] bg-cover bg-center blur-[75px]"
        }
      />

      <div className="relative z-10 flex w-full flex-col items-center gap-6 py-8">
        <h3 className={cn(textVariants.title3, "text-center")}>Tell me the foods you love</h3>

        <div className="flex items-center gap-3">
          <OutlinedButton
            color="black"
            textCase="normal"
            onClick={handleOpenAddFoodModal}
            className="gap-3"
          >
            <FavouritesIcon className="h-6 w-6" />
            Add food
          </OutlinedButton>
        </div>
      </div>

      <Divider />

      <div
        className="relative z-10 flex w-full items-center justify-between gap-2 bg-white/20 px-6 py-4.5"
        onClick={navigateToMyFoods}
      >
        <div className="flex items-center gap-3">
          <NumberBadge value={totalMeals} />
          <span className={cn(textVariants.title3, "text-center")}>Meals added already</span>
        </div>
        <RightIcon />
      </div>
      <AddFoodModal isOpen={isAddFoodModalOpen} onDismiss={handleCloseAddFoodModal} />
    </div>
  );
});
